import React, { useState } from 'react';
//import {Link, BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';
import {Form, FormGroup, Button, Label, Input, H2, Image, H3, Select} from './RegisterModal.styles';
//import Select from 'react-select'
import logo from '../../assets/logoRemuner.png'
import apis from '../../api';

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : RegisterModal
Description : Resto del formulario de registro
Date Autor Modification
================================================================================
30/09/2021 Santiago Coca Rojas Creación – Se implementa el forumlario desde cero.
================================================================================ */

export default function RegisterModal(props) {

    const [nombre, setNombre] = useState("");
    const [nombreEmpresa, setNombreEmpresa] = useState("");
    const [celular, setCelular] = useState("");
    const [empleados, setEmpleados] = useState("");
    const [frecuencia, setFrecuencia] = useState("");

    function validateForm() {
      return nombre.length > 0 && nombreEmpresa.length > 0 && 
             celular.length > 0 && empleados.length > 0 && frecuencia.length > 0;
    }

    function handleSubmit(event) {
      event.preventDefault();
    }

    async function completarRegistro() {
        console.log("Tu cucha "+props.email)
        const _email = props.email;
        const _nombre = nombre;
        const _nombreEmpresa = nombreEmpresa;
        const _celular = celular;
        const _empleados = empleados;
        const _frecuencia = frecuencia;
        
        let _userID = "";

        console.log("Sapo "+_email)
        await apis.getUserByUsername(_email).then(res => {
            console.log(res)
            console.log("Esta cosa "+res.data[0].USER_ID)
            _userID = res.data[0].USER_ID
            const company = {
                company_name: _nombreEmpresa,
                numbre_employees: _empleados,
                frequency: _frecuencia,
                phone: _celular,
                user_id: _userID,
                name: _nombre,
                doc_type: null,
                doc_number: null,
                arl: null,
                bank: null,
                account_type: null,
                account_number: null,
                sector: null,
                logo: null,
                firm: null
            }
            console.log("El json")
            console.log(company)
            apis.insertCompany(company).then(res2 => {
                console.log(res2.data)
                window.alert("Error al agregar el usuario o la empresa")
            })
        })

        /*console.log("Este es: "+_userID) 
        const company = {
            company_name: _nombreEmpresa,
            numbre_employees: _empleados,
            frequency: _frecuencia,
            phone: _celular,
            user_id: _userID,
            name: _nombre
        }
        apis.insertCompany(company).then(res => {
            console.log(res.data)
            window.alert("Error al agregar el usuario o la empresa")
        })*/
    }

    return (
        <Form onSubmit={handleSubmit}>
            <H2>
                <Image src={logo} alt="Remuner Lite"/>  
            </H2>
            <H3>Registro</H3>
            <FormGroup>
                <Label htmlFor="label">Nombre</Label>
                <Input 
                id="label1"
                autoFocus 
                type="text" 
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
                />
            </FormGroup>
            <FormGroup>
                <Label htmlFor="label">Nombre de la empresa</Label>
                <Input 
                id="label2"
                autoFocus 
                type="text" 
                value={nombreEmpresa}
                onChange={(e) => setNombreEmpresa(e.target.value)}
                />
            </FormGroup>
            <FormGroup>
                <Label htmlFor="label">Teléfono celular</Label>
                <Input 
                id="label3"
                autoFocus 
                type="text" 
                value={celular}
                onChange={(e) => setCelular(e.target.value)}
                />
            </FormGroup>
            <FormGroup>
                <Label htmlFor="label">Número de empleados</Label>
                <Select value={empleados} onChange={(e) => setEmpleados(e.target.value)}>
                    <option value="" hidden>Cantidad</option>
                    <option value="1-5">1-5</option>
                    <option value="5-10">5-10</option>
                    <option value="10-20">10-20</option>
                    <option value="20-30">20-30</option>
                </Select>
            </FormGroup>
            <FormGroup>
                <Label htmlFor="label">Frecuencia de nómina</Label>
                <Select value={frecuencia} onChange={(e) => setFrecuencia(e.target.value)}>
                    <option value="" hidden>Frecuencia</option>
                    <option value="Quincenal">Quincenal</option>
                    <option value="Mensual">Mensual</option>
                </Select>
            </FormGroup>
            <Button block type="submit" disabled={!validateForm()} onClick={completarRegistro}>
                Finalizar
            </Button>
        </Form>
    );
  }